// extracted by mini-css-extract-plugin
module.exports = {"EditorialTwoColumnsContact":"styles_EditorialTwoColumnsContact__TjpJu","item":"styles_item__vz_Wl"};